import { render, staticRenderFns } from "./DocClothing.vue?vue&type=template&id=9317a814&scoped=true"
import script from "./DocClothing.vue?vue&type=script&lang=js"
export * from "./DocClothing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9317a814",
  null
  
)

export default component.exports